import React, { FunctionComponent, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type FC = FunctionComponent;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const FiservSuccess: FC = () => {
  const params = useQuery();

  useEffect(() => { 
    window.parent.postMessage({
      step: "FISERV_COMPLETE",
      fiLoginAcctId: params.get('fiLoginAcctId') || "",
      acctId: params.get('acctId') || ""
    }, '*');

    if(params.get('action')){
      window.parent.postMessage({
        step: "FISERV_CANCEL",
        action: params.get('action') || "",
      }, '*');
    }

    if(params.get('errorCode')){
      window.parent.postMessage({
        step: "FISERV_ERROR",
        errorCode: params.get('errorCode') || "",
      }, '*');
    }
  }, [params]);

  return (
    <></>
  );
};

export default FiservSuccess;